<template>
  <div class="mt-3" style="font-size: 80%">
    <div class="accordion mb-2" id="accordionTravelExpense">
      <div class="shadow">
        <button
          class="btn btn-success btn-sm w-100"
          @click="buttonNuevo()"
          type="button"
          data-toggle="collapse"
          data-target="#collapseTravelExpense"
          aria-expanded="false"
          aria-controls="collapseTravelExpense"
        >
          <i class="fas fa-plus-circle"></i>
          New Travel Expenses
        </button>

        <div
          id="collapseTravelExpense"
          class="collapse"
          aria-labelledby="headingTravelExpense"
          data-parent="#accordionTravelExpense"
        >
          <div class="w-100 card-body shadow rounded bg-light">
            <b-form @submit.prevent="procesarFormulario">
              <div class="container">
                <div class="form-row mb-3">
                  <div class="col-md-8">
                    <label for="description" class="form-label font-weight-bold">Description</label>
                    <b-form-input
                      class="form-control"
                      size="sm"
                      v-model="form.description"
                      id="description"
                      required
                      placeholder="Ej: Flight - Direct 2h-4h"
                    ></b-form-input>
                  </div>
                  <div class="col-md-2">
                    <label for="price" class="form-label font-weight-bold">Price</label>
                    <b-form-input
                      type="number"
                      step="0.01"
                      class="form-control"
                      size="sm"
                      v-model="form.price"
                      id="price"
                      required
                    ></b-form-input>
                  </div>
                  <div class="col-md-2">
                    <label for="type" class="form-label font-weight-bold">Type</label>
                    <b-form-select
                      v-model="form.type"
                      id="type"
                      :options="[{value: 'transporte', text: 'Transporte'}, {value: 'hotel', text: 'Hotel'}]"
                      size="sm"
                      required
                    ></b-form-select>
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-3">
                <b-button
                  variant="outline-danger"
                  size="sm"
                  class="mr-2"
                  data-toggle="collapse"
                  data-target="#collapseTravelExpense"
                  @click="resetForm()"
                  ><i class="far fa-times-circle mr-1"></i>Cancelar</b-button
                >
                <b-button
                  variant="primary"
                  size="sm"
                  type="submit"
                  data-toggle="collapse"
                  data-target="#collapseTravelExpense"
                  ><i class="far fa-check-circle mr-1"></i>{{ editando ? 'Actualizar' : 'Guardar' }}</b-button
                >
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-3">
      <b-table
        responsive
        head-variant="light"
        :fields="camposTabla"
        :items="filteredItems"
        small
        hover
      >
        <template #cell(price)="row">
          {{ row.value }} €
        </template>
        <template #cell(accion)="row">
          <b-button-group size="sm">
            <b-button
              size="sm"
              variant="outline-success"
              data-toggle="collapse"
              data-target="#collapseTravelExpense"
              @click="buttonEditar(row.item)"
              class="mr-1"
            >
              <i class="fas fa-edit"></i>
            </b-button>

            <b-button
              size="sm"
              variant="outline-danger"
              @click="eliminar(row.item)"
            >
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { api1 } from "@/lib/http";

export default {
  name: "TravelExpenseMaintenanceComponent",
  props: {
    defaultType: {
      type: String,
      default: "transporte"
    }
  },
  data() {
    return {
      editando: false,
      form: {
        id: null,
        description: "",
        price: 0,
        type: "transporte"
      },
      camposTabla: [
        { key: "description", label: "Descripción", sortable: true },
        { key: "price", label: "Precio", sortable: true },
        { key: "type", label: "Tipo", sortable: true },
        { key: "accion", label: "", thStyle: { width: "100px" } },
      ],
      items: [],
    };
  },
  computed: {
    filteredItems() {
      if (!this.items) return [];
      return this.items.filter(item => {
        // Handle null/missing types as 'transporte' for backward compatibility
        const type = item.type || 'transporte';
        return type === this.defaultType;
      });
    }
  },
  methods: {
    async obtenerItems() {
      try {
        const { data } = await api1.get("/api/dekra-projects/v204/travel-expenses");
        this.items = data;
      } catch (error) {
        console.error("Error obteniendo gastos de viaje:", error);
      }
    },
    procesarFormulario() {
      if (this.editando) {
        this.actualizar();
      } else {
        this.guardar();
      }
    },
    async guardar() {
      try {
        await api1.post("/api/dekra-projects/v204/travel-expenses", this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al guardar:", error);
      }
    },
    async actualizar() {
      try {
        await api1.put(`/api/dekra-projects/v204/travel-expenses/${this.form.id}`, this.form);
        this.obtenerItems();
        this.resetForm();
      } catch (error) {
        console.error("Error al actualizar:", error);
      }
    },
    async eliminar(item) {
      if (!confirm("¿Seguro que quieres borrar este gasto de viaje?")) return;
      try {
        await api1.delete(`/api/dekra-projects/v204/travel-expenses/${item.id}`);
        this.obtenerItems();
      } catch (error) {
        console.error("Error al eliminar:", error);
      }
    },
    buttonNuevo() {
      this.editando = false;
      this.resetForm();
      this.form.type = this.defaultType;
    },
    buttonEditar(item) {
      this.editando = true;
      this.form = { ...item };
    },
    resetForm() {
      this.form = {
        id: null,
        description: "",
        price: 0,
        type: this.defaultType
      };
    }
  },
  mounted() {
    this.obtenerItems();
  }
};
</script>
